import React, { Component } from 'react'
import { Button, Icon, Select, Spin } from 'antd'
import _ from 'lodash'
import cx from 'classnames'

import './MemberList.scss'

const Option = Select.Option

export default class MemberList extends Component {
    getPMButtonClassname(authorized, deleted) {
        const { isAuthorized } = this.props
        return cx('pm-icon', {
            'active': authorized,
            'disabled': !isAuthorized || deleted
        })
    }

    renderListContent() {
        const { onMemberRemove, onMemberAuthChange, memberList, isAuthorized } = this.props

        if (_.isEmpty(memberList)) {
            return (
                <div className="member-list-loading">
					<Spin />
            	</div>
            )
        } else {
            return (
                <div className="member-list">
					<div className="member-name" key={memberList.created_by.member_id}>
						<span className="pm-icon active">PM</span>
                        { <span className={memberList.created_by.deleted ? 'deleted' : ''}>{memberList.created_by.first_name}</span> }
					</div>
					{
						_.map(memberList.members, (member, idx) => ( 
								<div className="member-name" key={member.member_id}>
                                    { 
                                        isAuthorized && !member.deleted ? 
                                        <span className={this.getPMButtonClassname(member.able_to_create, member.deleted)} onClick={onMemberAuthChange.bind(this, member.member_id, member.able_to_create)}>PM</span> :
                                        <span className={this.getPMButtonClassname(member.able_to_create, member.deleted)}>PM</span>
                                    }
                                    { <span className={member.deleted ? 'deleted' : ''}>{member.first_name}</span> }
                                    { isAuthorized && <Icon className="remove-btn" type="close" onClick={onMemberRemove.bind(this, member.member_id)}/> }
								</div> 
							)
						)
					}
				</div>
            )
        }
    }

    renderPanel() {
        const { onMemberAdd, onMemberChange, selectedProjectName, memberList, availableMemberList, selectedMember, isAuthorized } = this.props

        return (
            <div className="MemberList">
				<h3 className="project-title">{selectedProjectName}</h3>
				{this.renderListContent()}
				{
					isAuthorized &&
					<div className="add-member-gp">
						<Select
							value={selectedMember}
							disabled={_.isEmpty(memberList)}
	    					showSearch
							className="search-bar"
							placeholder="Select a member"
					        defaultActiveFirstOption={false}
					        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
					        onChange={onMemberChange}
						>
							{
								_.map(availableMemberList, (member, idx) => (
										<Option key={member._id}>{member.first_name}</Option>
									)
								)
							}
						</Select>
						<Button 
							disabled={_.isEmpty(memberList) || !selectedMember}
							className="add-btn"
							type="primary" 
							size="large"
							onClick={onMemberAdd}
						>
							Add
						</Button>
					</div>
				}
			</div>
        )
    }

    render() {
        const { selectedProjectName } = this.props

        if (selectedProjectName !== '') {
            return this.renderPanel()
        } else {
            return (
                <div className="MemberList">
					<div className="empty-alert">
						Select a project to manage the members
					</div>
				</div>
            )
        }
    }
}

MemberList.propTypes = {
    selectedProjectName: React.PropTypes.string.isRequired,
    memberList: React.PropTypes.object.isRequired,
    availableMemberList: React.PropTypes.array.isRequired,
    onMemberRemove: React.PropTypes.func.isRequired,
}

MemberList.defaultProps = {
    selectedProjectName: '',
    memberList: {},
    availableMemberList: []
}



// WEBPACK FOOTER //
// ./src/Commons/MemberList/MemberList.js